/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TemporalUnitResource = {
    Day: 'DAY',
    Hour: 'HOUR'
} as const;
export type TemporalUnitResource = typeof TemporalUnitResource[keyof typeof TemporalUnitResource];


export function instanceOfTemporalUnitResource(value: any): boolean {
    for (const key in TemporalUnitResource) {
        if (Object.prototype.hasOwnProperty.call(TemporalUnitResource, key)) {
            // @ts-ignore
            if (TemporalUnitResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TemporalUnitResourceFromJSON(json: any): TemporalUnitResource {
    return TemporalUnitResourceFromJSONTyped(json, false);
}

export function TemporalUnitResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemporalUnitResource {
    return json as TemporalUnitResource;
}

export function TemporalUnitResourceToJSON(value?: TemporalUnitResource | null): any {
    return value as any;
}

